//import { permissionCheck } from "./permission-check";
export const buildStudents = (navigation, strings,permissions,onClick) => {
  let baseUrl = navigation.region
    ? `/areas/${navigation.area.id}/regions/${navigation.region.id}`
    : `/areas/${navigation.area.id}/regions/na`;
  baseUrl = navigation.coordinator
    ? `${baseUrl}/coordinators/${navigation.coordinator.id}/programs/${navigation.program.id}`
    : `${baseUrl}/coordinators/na/programs/${navigation.program.id}`;

  baseUrl = `${baseUrl}/years/${navigation.year.id}/terms/${navigation.term.id}`;

  const hasTerm = !!navigation?.term;
  const item = {
    type: "link",
    label: strings.students,
    "data-id": "accordion-students",
    href: `${baseUrl}/students`,
    onClick:(e) => {
      onClick({
        event:e,
        href: `${baseUrl}/students`,
      });
    }
  };
  return hasTerm ? item : null;
};
